import classNames from "classnames";
import React, { ChangeEvent, useEffect, useState } from "react";

import "./checkbox.css";

export function Checkbox({
	id,
	checked,
	label,
	onChange,
	className,
}: {
	id: string;
	checked?: boolean;
	label: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	className?: string;
}) {
	const [isChecked, setIsChecked] = useState(checked);
	const classes = classNames(className, "checkbox", {
		"checkbox--checked": isChecked,
	});

	useEffect(() => {
		setIsChecked(checked);
	}, [checked]);

	return (
		<label className={classes} htmlFor={id}>
			<input
				id={id}
				className="checkbox__input"
				type="checkbox"
				checked={isChecked}
				onChange={(e) => {
					setIsChecked(!isChecked);
					onChange(e);
				}}
			/>
			<span className="checkbox__icon" />
			<span className="checkbox__label">{label}</span>
		</label>
	);
}
